import styled from 'styled-components';

const RequestBody = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export default RequestBody;
